export default __webpack_public_path__ + "static/media/chats.2ce7fe1b.svg";